
import featureService from '@/api/featureConfigService'
import { notify, notifyWarn } from "@/utils/notification-helper"

const state = {


    features: [],
    newFeature: {},
    edit: false,
    editData: {},
    auditLogs: [],
    totalAuditLogs: 0
}
const getters = {

    featureData: state => state.features,
    newFeature: state => state.newFeature,
    edit: state => state.edit,
    editFeature: state => state.editData

};

const actions = {

    async addFeature({ commit, rootState }, feature) {
        const reqRes = await featureService.addFeature(feature)
        if (reqRes.status == 200) {
            notify("Feature created successfully!");
          } else {
            notifyWarn("Unable to create Feature!")
          }
        rootState.features.push(feature)
        commit('add', feature)
    },
    editFeature({ commit }, feature) {
        commit('editData', feature)
    },
    async updateFeature({ commit }, feature) {
        const reqRes = await featureService.updateFeature(feature.id, feature)
        if (reqRes.status == 200) {
            notify("Feature updated successfully!");
          } else {
            notifyWarn("Unable to update Feature!")
          }
        commit('update', feature)
    },
    async removeFeature({ commit, rootState }, feature) {
        const reqRes = await featureService.removeFeature(feature.id)
        if (reqRes.status == 200) {
            notify("Feature deleted successfully!");
          } else {
            notifyWarn("Unable to delete Feature!")
          }
        var features = rootState.features
        const index = features.map(item => item.id).indexOf(feature.id)
        features.splice(index, 1)
        commit('remove', feature.id)
    },
    async getAuditLogs({commit}, data){
        let auditLog = await featureService.getUserAuditLogs(data.featureId, data.pageSize, data.pageNo);
        if(auditLog.status == 200){
            commit('setAuditLog', auditLog.data.result)
            commit('setTotalAuditLogs', auditLog.data.totalDataCount);
        }
    },
}
const mutations = {

    add(state, feature) {
        state.features.push(feature);
        state.newFeature = {}
    },
    edit(state, feature) {
        state.editId = feature.id
        state.edit = true
        state.newFeature = feature
        // router.push({ name: "addFeature", params: { add: true } });
    },
    editData(state, feature){
        state.editData = feature
    },
    update(state, feature) {
        var features = state.features
        const index = features.map(item => item.id).indexOf(feature.id)
        features.splice(index, 1)
        features.push(feature);


    },
    remove(state, feature) {
        var features = state.features
        const index = features.map(item => item.id).indexOf(feature.id)
        features.splice(index, 1)
    },
    cancel(state) {
        state.newFeature = {}
    },
    setAuditLog(state, data){
        state.auditLogs = data;
    },
    setTotalAuditLogs(state, data){
        state.totalAuditLogs = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}